import { FormControl, Grid, Input, InputAdornment, InputLabel, TextField, Typography } from "@mui/material";
import { MobileDateTimePicker, MobileTimePicker } from "@mui/x-date-pickers";
import CalendarIcon from '@mui/icons-material/CalendarMonth';
import { isAfter, isBefore, setHours, isSameDay, isFuture, endOfDay } from "date-fns";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { appRoutes } from "../AppRoutes";
import AppFooter from "../components/AppFooter";
import BodyContainer from "../components/BodyContainer";
import FooterButtons from "../components/FooterButtons";
import PhoneNumberInput from "../components/form/PhoneNumberInput";
import AppHeader from "../components/AppHeader";
import { useDispatch, useSelector } from "react-redux";
import { setComments, setInfo } from "../store/submission.slice";

const BurnInfo = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const data = useSelector(state => state.submission.info);

	const comments = useSelector(state => state.submission.comments);
	const [values, setValues] = useState({
		name: data.name,
		phoneNum: data.phoneNum,
		startDate: data.startDate,
		endDate: data.endDate
	});

	const [isValid, setIsValid] = useState(false);

	// Default start date to current date and time and autofill current timestamp (nearest half hour)
	// Default end date to current date and autofill time to 11:59 pm
	useEffect(() => {
		const endDate = new Date(setHours(values.startDate, 23).setMinutes(59));
		// const endDate = new Date(setHours(values.endDate, 23).setMinutes(59));
		setValues({...values, endDate});
		// setValues({...values, startDate, endDate});
	}, [values.startDate])

	useEffect(() => {
		const isValid = isFormValid();
		setIsValid(isValid);

		if (isValid) {
			dispatch(setInfo({
				...values,
				startDate: new Date(values.startDate).getTime(),
				endDate: new Date(values.endDate).getTime()
			}));
		}
	}, [values])

	const isFormValid = useCallback(() => {
		const { name, phoneNum, startDate, endDate} = values;
		const formattedPhone = phoneNum.replace(/\s/g, '').replace(/[()]/g, '').replace(/-/g,'');
		return (
			!!name && name.trim().length > 0 &&
			!!formattedPhone && formattedPhone.length === 10 &&
			// !!startDate && isToday(startDate) &&
			!!startDate &&
			!!endDate && isAfter(endDate, startDate)
		);

	}, [values])

	const onNext = () => {
		const isValid = isFormValid();
		if (!isValid) return;
		navigate(appRoutes.Review);
	}

	return (
		<>
		 	<AppHeader />
			<BodyContainer hasFooter={false} hasHeader={true}>
				<Grid item xs="auto" mb={2} mt={2} width="100%">
					<Typography variant="title" component="h1">Burn Safety Contact Information</Typography>
					<Typography variant="subtitle2" component="h2">
						Contact information is collected for safety purposes during the burn. Name, phone number, and the burn GPS location will be purged from burn checklist records 24 hours after the end time for a row crop burn and 2 weeks after the end time for a forestry burn.
					</Typography>
				</Grid>
				<Grid item container xs="auto" sx={{width: '100% !important'}}>
					<div style={{minHeight: '300px', display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'space-between'}}>
					<FormControl variant="standard" required fullWidth mb={2}>
						<InputLabel shrink htmlFor="name">Name</InputLabel>
						<Input
						id="name"
						onChange={v => (/^([^0-9]*)$/g).test(v.target.value) && setValues({...values, name: v.target.value})}
						value={values.name}
						placeholder="Name"
						type="text"
						inputProps={{maxLength: 50, pattern: "[a-zA-Z]*"}}/>
					</FormControl>
					<FormControl variant="standard" required fullWidth mb={2}>
						<InputLabel shrink htmlFor="phone">Phone Number</InputLabel>
						<PhoneNumberInput
						id="phone"
						onChange={v => setValues({...values, phoneNum: v.target.value})}
						value={values.phoneNum}
						placeholder="(xxx) xxx-xxxx"/>
					</FormControl>
					<FormControl variant="standard" required fullWidth mb={2}>
						<InputLabel shrink htmlFor="startdate">Start Date</InputLabel>
						<MobileDateTimePicker
						onChange={(d) => setValues({...values, startDate:d})}
						value={values.startDate}
						disablePast
						id="startdate"
						shouldDisableDate={d => isAfter(d, endOfDay(new Date()))  }
						renderInput={(params) => (
							<Input {...params} endAdornment={<InputAdornment position="end"><CalendarIcon /></InputAdornment>} />
						)} />
					</FormControl>
					<FormControl variant="standard" required fullWidth>
						<InputLabel shrink htmlFor="enddate">End Date</InputLabel>
						<MobileDateTimePicker
						id="enddate"
						value={values.endDate}
						disablePast
						shouldDisableDate={d => (isBefore(d, values.startDate) && !isSameDay(d, values.startDate)) || isAfter(d, endOfDay(new Date()))  }
						onChange={d => setValues({...values, endDate:d})}
						// views={["day"]}
						renderInput={(params) => (
							<Input {...params} endAdornment={<InputAdornment position="end"><CalendarIcon /></InputAdornment>} />
						)} />
					</FormControl>
					</div>
				</Grid>
				<Grid item xs="auto" mt={4} sx={{width: '100% !important'}}>
						{/* <Typography mb={1} variant="subtitle" component="h2">Provide any additional information concerning your burn</Typography> */}
						<InputLabel shrink htmlFor="comments" sx={{display: 'inline-block', wordBreak:'break-word',width:'135%',whiteSpace:'break-spaces'}}>
							Provide any additional information concerning your burn (e.g., burn will continue into next day, structures on the property, etc.)
						</InputLabel>
						<TextField 
						id="comments"
						value={comments}
						onChange={(c) => dispatch(setComments(c.target.value))}
						sx={{width: '100%'}}
						multiline
						rows={4}
						maxLength={250}/>
					</Grid>
				<Grid item xs="auto" mt={4} sx={{width: '100% !important'}}>
					<FooterButtons onNext={onNext} onBack={() => navigate(appRoutes.PlannedBurns)} backLabel="Go Back" nextDisabled={!isValid}/>
				</Grid>
			</BodyContainer>
			{/* <AppFooter /> */}
		</>
	)
}

export default BurnInfo;